module.exports = __webpack_public_path__ + "static/img/3_1.20314d38.png";